/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CatastralUnitResource { 
    /**
     * The code of the catastral unit.
     */
    code: string;
    /**
     * The name of the catastral unit.
     */
    name: string;
    /**
     * The code of the municipality.
     */
    municipalityCode: string;
    /**
     * Indicates if the catastral unit has a digital map.
     */
    hasDigitalMap: boolean;
    /**
     * Indicates if the catastral unit is active.
     */
    isActive: boolean;
    /**
     * The date when the catastral unit was established.
     */
    establishedDate: string;
    /**
     * The date when the catastral unit was terminated.
     */
    terminatedDate: string | null;
}

